export default "__VITE_ASSET__eL03mfA0__"